// Mock data for testimonials and FAQ
// This data is used as static content - not fetched from backend

export const faqData = [
  {
    question: "Who is this best for?",
    answer: "This coaching is ideal for busy professionals who want structure, accountability, and sustainable results. Whether you're looking to lose fat, build muscle, or simply get healthier, if you're ready to commit consistently, this is for you."
  },
  {
    question: "What if I've tried coaching/programs before?",
    answer: "Most programs fail because they're not personalized to your life. This coaching is built around YOUR schedule, preferences, and body. Plus, you get direct access to me for real-time adjustments—not a generic plan with no support."
  },
  {
    question: "Do you work with beginners?",
    answer: "Absolutely. I work with people at all fitness levels. Whether you're just starting or you've been training for years, your plan will be customized to where you are right now."
  },
  {
    question: "How much time does this take weekly?",
    answer: "Training typically requires 3-5 sessions per week, ranging from 45-75 minutes each. Nutrition planning takes minimal time once you understand the framework. Weekly check-ins are quick but essential for progress."
  },
  {
    question: "Is nutrition flexible?",
    answer: "Yes. I don't believe in restrictive diets that aren't sustainable. Your nutrition plan will be built around foods you enjoy while hitting your goals. No meal prep obsession required—just smart, flexible eating."
  },
  {
    question: "What happens after I apply?",
    answer: "After you submit your application, I'll review your answers to see if we're a good fit. If so, I'll reach out to schedule a quick call to discuss your goals and how coaching works. No pressure, no sales tactics—just an honest conversation."
  }
];

export const coachImages = {
  hero: "/ramzy-hero.jpg",
  lifestyle: "/ramzy-lifestyle.jpg",
  physique: "/ramzy-physique.jpg",
  before: "/ramzy-before.jpg",
  after: "/ramzy-after.jpg"
};

export const aboutMe = {
  title: "About Me",
  paragraphs: [
    "My fitness journey started from a place of feeling unhappy with my body and lacking confidence in myself. I tried different workouts and diets, but without the right structure or guidance, I struggled to stay consistent and make lasting progress.",
    "Once I learned how to train effectively, fuel my body properly, and build habits I could maintain, everything changed. Fitness helped me transform not only my physique, but also my confidence, discipline, and overall quality of life.",
    "Now, I use what I've learned through my own journey to help others avoid the mistakes I made and create transformations they can sustain long term."
  ]
};

// List of countries for dropdown
export const countries = [
  "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda", 
  "Argentina", "Armenia", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", 
  "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bhutan", "Bolivia", 
  "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria", "Burkina Faso", 
  "Burundi", "Cabo Verde", "Cambodia", "Cameroon", "Canada", "Central African Republic", 
  "Chad", "Chile", "China", "Colombia", "Comoros", "Congo", "Costa Rica", "Croatia", 
  "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", 
  "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", 
  "Ethiopia", "Fiji", "Finland", "France", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", 
  "Greece", "Grenada", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Honduras", 
  "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Italy", 
  "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea North", "Korea South", 
  "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", 
  "Liechtenstein", "Lithuania", "Luxembourg", "Madagascar", "Malawi", "Malaysia", "Maldives", 
  "Mali", "Malta", "Marshall Islands", "Mauritania", "Mauritius", "Mexico", "Micronesia", 
  "Moldova", "Monaco", "Mongolia", "Montenegro", "Morocco", "Mozambique", "Myanmar", "Namibia", 
  "Nauru", "Nepal", "Netherlands", "New Zealand", "Nicaragua", "Niger", "Nigeria", "North Macedonia", 
  "Norway", "Oman", "Pakistan", "Palau", "Palestine", "Panama", "Papua New Guinea", "Paraguay", 
  "Peru", "Philippines", "Poland", "Portugal", "Qatar", "Romania", "Russia", "Rwanda", 
  "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent and the Grenadines", "Samoa", "San Marino", 
  "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", 
  "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Sudan", 
  "Spain", "Sri Lanka", "Sudan", "Suriname", "Sweden", "Switzerland", "Syria", "Taiwan", 
  "Tajikistan", "Tanzania", "Thailand", "Timor-Leste", "Togo", "Tonga", "Trinidad and Tobago", 
  "Tunisia", "Turkey", "Turkmenistan", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", 
  "United Kingdom", "United States", "Uruguay", "Uzbekistan", "Vanuatu", "Vatican City", 
  "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe"
];
